'use client';

import { Monitor, Moon, Sun } from 'lucide-react';
import { SegmentedControl } from './segmented-control';
import { useTheme } from '@/lib/theme/theme-provider';
import type { ThemePreference } from '@/lib/theme/theme';

/** System / Light / Dark picker (DESIGN.md §9). */
export function ThemeToggle({
  size = 'md',
  className,
  fill = false,
  compact = false,
  labels = {
    label: 'Appearance',
    system: 'System',
    light: 'Light',
    dark: 'Dark',
  },
}: {
  size?: 'sm' | 'md';
  className?: string;
  fill?: boolean;
  compact?: boolean;
  labels?: { label: string; system: string; light: string; dark: string };
}) {
  const { preference, setPreference } = useTheme();

  return (
    <SegmentedControl<ThemePreference>
      label={labels.label}
      size={size}
      className={className}
      fill={fill}
      compact={compact}
      value={preference}
      onChange={setPreference}
      items={[
        { value: 'system', label: labels.system, icon: <Monitor aria-hidden="true" /> },
        { value: 'light', label: labels.light, icon: <Sun aria-hidden="true" /> },
        { value: 'dark', label: labels.dark, icon: <Moon aria-hidden="true" /> },
      ]}
    />
  );
}
